<div class="side-panel" [class.opened]="open">
	<ng-content />
</div>
